<div class="w-full h-full flex flex-col items-center gap-10 px-4 py-8">
  <br />
  <div class="max-w-[580px] w-full flex flex-col gap-6">
    <div class="flex items-center">
      <img src="/icons/bang.svg" alt="advertencia" style="margin-right: 10px" />
      <h1 class="titulo">{{ configuracionActual().titulo }}</h1>
    </div>

    <p class="texto">{{ configuracionActual().descripcion }}</p>
    <br />
    <!-- Botones de acción -->
    @if (configuracionActual().textoBoton) {
      <div class="w-full flex justify-center">
        <button class="boton" (click)="navegarALogin()">
          {{ configuracionActual().textoBoton }}
        </button>
      </div>
    }
  </div>
</div>
